import { NavLink } from "react-router-dom";
import "./Sidebar.css";
import logo from "../../../../assets/img/topbar/logo.png";

const Sidebar = ({ isOpen, closeSidebar, isCollapsed = false }) => {
  return (
    <div
      className={`sidebar ${isOpen ? "open" : ""} ${isCollapsed ? "collapsed" : ""}`}
    >
      <div className="logo-container">
        <div className="text-center py-3">
          <img src={logo} alt="Logo" className="logo-img" />
        </div>
        <button className="close-sidebar" onClick={closeSidebar}>
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
      <nav className="sidebar-nav">
        <NavLink
          to="/teacher/dashboard"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-house-door"></i>
          <span>Home</span>
        </NavLink>
        <NavLink
          to="/teacher/student"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-people"></i>
          <span>Students</span>
        </NavLink>
        <NavLink
          to="/teacher/classroom"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-grid"></i>
          <span>Classroom</span>
        </NavLink>
        <NavLink
          to="/teacher/lesson"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-book"></i>
          <span>Lessons</span>
        </NavLink>
        <NavLink
          to="/teacher/quest"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-trophy"></i>
          <span>Quests</span>
        </NavLink>
        <NavLink
          to="/teacher/quiz"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-pencil-square"></i>
          <span>Quiz Attempt Limit</span>
        </NavLink>
        <NavLink
          to="/teacher/import-history"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="fa-solid fa-database"></i>
          <span>Import History</span>
        </NavLink>
        <NavLink
          to="/teacher/notifications"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-bell"></i>
          <span>Notifications</span>
        </NavLink>
        <NavLink
          to="/teacher/settings"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-gear"></i>
          <span>Settings</span>
        </NavLink>
      </nav>
    </div>
  );
};

export default Sidebar;
